import {
  IImageObjectRef,
  ImageObjectType,
} from '../../../../../modules/API/Images/models/imageObject'
import { IOrderItem } from '../../../../../modules/API/Drivers/models/kavData'

/**
 * Адрес фотографий строки заказа. Тип DELIVERY означает, что ObjectID — это
 * номер теуды, поэтому вызывать имеет смысл только для строк с теудой.
 */
export const buildDeliveryImageRef = (
  order: Pick<IOrderItem, 'Delivery_Num' | 'Delivery_Sub'>,
): IImageObjectRef => ({
  ObjectType: ImageObjectType.DELIVERY,
  ObjectID: order.Delivery_Num,
  ObjectSubID: order.Delivery_Sub,
})

/**
 * Адрес фотографий строки кава. Проблема приоритетнее теуды: теуда могла быть
 * выписана давно, актуальные фото — у проблемы. Без того и другого фото нет.
 */
export const buildOrderImageRef = (
  order: Pick<IOrderItem, 'Delivery_Num' | 'Delivery_Sub' | 'OrderID' | 'IsProblem'>,
): IImageObjectRef | null => {
  if (order.IsProblem) {
    return {
      ObjectType: ImageObjectType.PROBLEM,
      // У проблемы OrderID есть всегда; гард — чтобы не упасть на битых данных.
      ObjectID: order.OrderID || 0,
      ObjectSubID: 0,
    }
  }
  return order.Delivery_Num !== 0 ? buildDeliveryImageRef(order) : null
}
